export const promoBanners = {
  promoBannerAlt: "Promosiebanier",
  promoBannerSlide: "Skuif",
  tagDrop: "Drop",
  tagTorneo: "Toernooi",
  tagRace: "Wedloop",
  tagNuevo: "Nuut",
  tagPromo: "Promo",
};
